
type TOption = { value: string; label: string; };
export const uniqueOptions = (options: TOption[] = []): TOption[] => {
  const reduced = options.reduce((acc, v) => ({ ...acc, [v.value]: v }), {});
  return Object.values(reduced);
};
